import { FilledButton, StyledSvg, useTextFormatter } from '@make-software/tg-mini-app-ui';

import { ButtonWrapper, ModalDescription } from '@/shared';
import GoldIcon from '@/shared/assets/icons/gold.svg';

import { StyledContent } from './unknown-wallet-content.styled';

interface UnknownWalletProps {
  onConnectWallet?: () => void;
  onDownloadWallet?: () => void;
}

export const UnknownWalletContent = ({ onConnectWallet, onDownloadWallet }: UnknownWalletProps) => {
  const formatter = useTextFormatter();

  return (
    <>
      <StyledContent>
        <ModalDescription>
          Connect your Wallet and earn{' '}
          {formatter.formatPoints(parseInt(window.config.season_info.wallet_connection_reward, 10))}{' '}
          fan points. Don't have a wallet? Download it via the link below and receive additional fan
          points.
        </ModalDescription>
      </StyledContent>
      <ButtonWrapper direction={'column'}>
        <FilledButton
          fontFamily="Inter"
          title={
            <span>
              Connect&nbsp;&nbsp;&nbsp;
              <StyledSvg src={GoldIcon} size={16} fillColor="#F1BF0B" />{' '}
              {formatter.formatPoints(window.config.season_info.wallet_connection_reward)}{' '}
            </span>
          }
          onClick={onConnectWallet}
          borderRadius="0"
        />
        {window.config.season_info.wallet_download_reward === '1' && (<FilledButton
          fontFamily="Inter"
          title={
            <span>
              Download Wallet&nbsp;&nbsp;&nbsp;
              <StyledSvg src={GoldIcon} size={16} fillColor="#F1BF0B" />{' '}
              {formatter.formatPoints(window.config.season_info.wallet_download_reward)}{' '}
            </span>
          }
          onClick={onDownloadWallet}
          base={{ backgroundColor: '#30313B' }}
          borderRadius="0"
        />)}
      </ButtonWrapper>
    </>
  );
};
